module.exports = __webpack_public_path__ + "static/img/coin-grey.45db306.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coin-grey.jpg
// module id = gPcR
// module chunks = 1